export default "__VITE_ASSET__DqGyWduA__"